import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import Resume from "./routes/Resume";
import Bookshelf from "./routes/Bookshelf";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  // {
  //   path: "/resume",
  //   element: <Resume />,
  // },
  {
    path: "/bookshelf",
    element: <Bookshelf />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
